/* eslint-disable no-shadow */
export interface User {
  _id: string;
  sfId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  cognitoId: null;
  globalAccounts: string[];
  accounts?: {
    accountId: string;
    roles: string[];
    acrSfId?: string;
  }[];
  account: {
    accountId: string;
    roles: string[];
    acrSfId?: string;
    account?: {
      _id: string;
      name: string;
      sfId: string;
    };
    globalAccount?: {
      _id: string;
      name: string;
      sfId: string;
    };
  };
  lastDayOfMember: string;
  primaryAccount?: string;
  memberPortalEnabled: boolean;
  memberSince: string;
  memberPortalRole: MemberPortalRole | null;
  role: string;
  identityVerifications?: {
    status: IdentityVerificationStatus;
    deadlineDateIso: string;
  }[];
}

export enum MemberPortalRole {
  HQEmployee = "HQ Employee",
  OperationalManager = "Operational Manager",
  CoworkingMember = "Coworking Member",
}

export enum IdentityVerificationStatus {
  Required = "Required",
  Verified = "Verified",
  Failed = "Failed",
  Overridden = "Overridden",
}

export const IDENTITY_VERIFICATION_STATUSES_REQUIRING_ACTION = [
  IdentityVerificationStatus.Required,
  IdentityVerificationStatus.Failed,
];
